<template>
  <div class="col-12">
    <div class="card-body">
      <div class="col-md-12 breadcumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/principal' }">Home</el-breadcrumb-item>
          <el-breadcrumb-item>{{
            $t("app.modules.add_by_part_number.title")
          }}</el-breadcrumb-item>

          <h6 style="margin-bottom: 0px" class="text-right">
            {{ $t("app.welcome") }} {{ this.$store.state.user.nombre }}
          </h6>
          <!--<td class="col-md-12 breadcumb" style="width: 875px;"></td>  
            <td><h7 style="margin-bottom: 0px" class="text-right">{{ this.$store.state.user.cliente.razonSocial }}  </h7></td>-->
          <td></td>
          <td></td>
        </el-breadcrumb>
        <td class="col-11"></td>
        <td class="col-2">
          <h7 style="margin-bottom: 0px" class="text-right">{{ this.$store.state.user.cliente.razonSocial }}
          </h7>
        </td>
      </div>

      <el-divider></el-divider>
      <div class="row">
        <div class="col-12">
          <h4>{{ $t("app.modules.add_by_part_number.title") }}</h4>
          <p class="text-muted">
            {{ $t("app.modules.add_by_part_number.subtitle") }}
          </p>
          <div class="row">
            <div class="col-12">
              <div class="card">
                <div class="card-body">
                  <div class="row">
                    <div class="col-1"></div>
                    <div class="col-10">
                      <div class="form-group">

                      </div>

                      <div class="add-product-container" v-for="(p, k) in productsList">
                        <div class="row" style="margin-top: 15px">
                          <div class="col-4">
                            <div class="form-group">
                              <fg-input type="text" :label="$t(
                                  'app.modules.add_by_part_number.part_number'
                                )
                                " v-model="p.partnumber" @blur="getProductDetailVal(p.partnumber)">
                              </fg-input>
                            </div>
                          </div>

                          <div class="col-4">
                            <div class="form-group">
                              <fg-input type="number" :label="$t(
                                  'app.modules.product_family_detail.headers.quantity'
                                )
                                " v-model="p.quantity">
                              </fg-input>
                            </div>
                          </div>

                          <div class="col-4">
                            <n-button native-type="button" type="success" :title="$t('app.buttons.add')"
                              @click.native="addProductContainer" size="md">
                              <!--
                              <i class="fa fa-plus"></i>
                              -->
                              {{
                                $t(
                                  "app.modules.add_by_part_number.button.addPartNumber"
                                )
                              }}
                            </n-button>

                            <n-button native-type="button" type="danger" :title="$t('app.buttons.add')"
                              @click.native="removeProductContainer(k)" size="md" v-if="productsList.length > 1">
                              <!--
                              <i class="fa fa-minus"></i>
                              -->

                              {{
                                $t(
                                  "app.modules.add_by_part_number.button.deletePartNumber"
                                )
                              }}
                            </n-button>
                          </div>
                        </div>

                        <!--
                    <div class="row" style="margin-top: 15px">
                      <div class="col-6"></div>
                      <div class="col-6">
                        <div class="form-group" style="text-align: right">
                          <label>{{
                            $t(
                              "app.modules.product_family_detail.headers.price"
                            )
                          }}</label>
                          <h3>{{ priceTitle }}</h3>
                        </div>
                      </div>
                    </div>
                    -->
                      </div>
                    </div>
                    <div class="col-1"></div>
                  </div>
                  <div slot="footer" style="
                      margin-top: 10px;
                      padding-top: 20px;
                      border-top: outset;
                    " class="text-right">
                    <!--
                    <n-button
                      native-type="button"
                      @click.native="irAlCarrito()"
                      type="primary"
                      >{{
                        $t("app.modules.add_by_part_number.button.viewshopping")
                      }}</n-button
                    >-->

                    <n-button native-type="button" @click.native="addProducto" type="primary">{{
                      $t("app.modules.add_by_part_number.button.add")
                    }}</n-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FamiliaProducto from "@/models/familiaProducto/FamiliaProducto";
import { getResponse, number_format } from "@/util/utilities";

export default {
  name: "CartAddByPartNumber",
  computed: {
    filtersData() {
      let result = [];

      let count = 0;
      for (const filter of this.filters) {
        if (count === 0) result.push(this.tableData[count]);

        if (!!filter.value) {
          let nextIndex = count + 1;
          if (nextIndex <= this.filters.length - 1) {
            let ids = this.getIds(this.tableData[count], filter.value);

            if (ids.length > 0) {
              let subdata = [];
              ids.forEach((val) => {
                subdata.push(this.tableData[nextIndex][val]);
              });
              result.push(subdata);
            }
          }
        } else break;
        count++;
      }

      return this.eliminarRepetidos(result);
    },
    priceTitle() {
      return this.price === 0
        ? this.$t("app.modules.product_family_detail.errors.not_available")
        : this.price + " " + this.moneda + "/" + this.unidad;
    },
  },
  data() {
    return {
      idFamilia: 0,
      product_family: new FamiliaProducto(),
      curTrad: null,
      icon: "",
      groups: [],
      features: [],
      products: [],
      filters: [],
      tableData: [],
      addresses: [],
      quantity: 0,
      delivery_date: "",
      direccionId: "",
      price: 0,
      moneda: "",
      unidad: "",
      idProductoCliente: 0,
      partnumber: "",
      detallesProducto: [],
      productsList: [
        {
          direccionId: null,
          partnumber: null,
          quantity: null,
        },
      ],
      detalleProducto: [],
      cantidadMinima: 0,
      idDireccion: 0,
    };
  },
  async mounted() {
    //console.log("entro a mounted");
    await this.init();
  },
  methods: {
    number_format,
    async init() {
      //console.log("entro a int");
      this.reset();
      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html: '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',

        showConfirmButton: false,
      });

      //await this.obtenerDirec();

      setTimeout(() => {
        this.$swal.close()
      }, 1000);


    },

    irAlCarrito() {
      this.$router.push({
        name: "Solicitar Pedido",
      });
    },

    async addProductContainer() {
      this.productsList.push({
        direccionId: null,
        partnumber: null,
        quantity: null,
      });
    },

    removeProductContainer(index) {
      this.productsList.splice(index, 1);
    },

    async loadProductFamily(id) {
      this.product_family.idFamiliaProducto = id;

      let param = {
        claveIdioma: this.$store.state.lang,
        id: id,
        usuario: 0,
      };

      let request = await this.$http.put(
        route("FamiliasProducto/getFamiliaProducto"),
        param
      );
      let response = getResponse(request, null);

      if (response) {
        await this.increaseViews(id);
        this.product_family = response.familiasProductos[0];

        if (!!this.product_family.iconografia) {
          let icons = this.product_family.iconografia;
          let json = JSON.parse(icons);
          if (json.length > 0) {
            this.icon = json[0];
          }
        }

        let trad = this.product_family.traducciones.filter(
          (t) => t.idioma.clave === this.$store.state.lang
        );
        if (!!trad) {
          this.curTrad = trad[0];
        }

        if (this.product_family.propiedades != null) {
          this.product_family.propiedades.forEach((prop) => {
            let g = this.groups.filter(
              (g) =>
                g.id === prop.grupoPropiedadFamiliaProducto.idGrupoPropiedad
            );

            if (g.length === 0) {
              let group = {
                id: prop.grupoPropiedadFamiliaProducto.idGrupoPropiedad,
                name: prop.grupoPropiedadFamiliaProducto.nombreGrupo,
                propiedades: [],
              };

              group.propiedades.push(prop);
              this.groups.push(group);
            } else g[0].propiedades.push(prop);
          });
        }

        param.idFamiliaProducto = id;
        let requestProd = await this.$http.post(
          route("Productos/getProductosByFamilia"),
          param
        );
        let responseProd = getResponse(requestProd);

        if (responseProd != null) {
          let productos = (this.products = responseProd.productos);

          productos.forEach((producto) => {
            if (producto.caracteristicasProductos.length > 0) {
              producto.caracteristicasProductos.forEach((caract) => {
                if (
                  !this.filters.find(
                    (f) => f.id === caract.idcaracteristicasProducto
                  )
                ) {
                  this.filters.push({
                    id: caract.idcaracteristicasProducto,
                    name: caract.nombreAtributo,
                    value: "",
                  });
                }
              });
            }
          });

          if (this.filters.length > 0) {
            let cProduct = 0;
            productos.forEach((producto) => {
              if (producto.caracteristicasProductos.length > 0) {
                producto.caracteristicasProductos.forEach((caract) => {
                  let index = this.filters.findIndex(
                    (f) => f.id === caract.idcaracteristicasProducto
                  );

                  if (!this.tableData[index]) this.tableData[index] = [];

                  let json = JSON.parse(caract.valorAtributo);

                  this.tableData[index][cProduct] = {
                    id: cProduct,
                    name: json[caract.valorCaracteristica],
                    idProducto: producto.idProducto,
                  };
                });
              }
              cProduct++;
            });
          }
        }

        if (this.$store.state.user.idClienteSAP > 0) {
          let paramClient = {
            clienteId: this.$store.state.user.idClienteSAP,
          };
          let requestDir = await this.$http.post(
            route("Clientes/getDireccionesByCliente"),
            paramClient
          );
          let responseDir = getResponse(requestDir);

          if (responseDir != null) {
            this.addresses = responseDir.direcciones;
          }
        }
      } else this.notifyMessage("danger", this.$t("app.promps.error"));
    },
    /*
    async obtenerDirec() {
      if (this.$store.state.user.idClienteSAP > 0) {
        let paramClient = {
          clienteId: this.$store.state.user.idClienteSAP,
        };
        let requestDir = await this.$http.post(
          route("Clientes/getDireccionesByCliente"),
          paramClient
        );
        let responseDir = getResponse(requestDir);

        if (responseDir != null) {
          this.addresses = responseDir.direcciones;
          this.addresses.unshift({
            idDireccion: 0,
            direccionString: "Select address",
          });
        }
      }
    },
    */
    async validateProduc() {
      let errors = [];
      let validItems = [];

      //console.log("entra a validateproduct ");

      if (this.productsList.length > 0) {
        //console.log("this.productsList.length: " + this.productsList.length);
        for (let p of this.productsList) {
          let param = {
            //direccionId: this.idDireccion,
            clienteIdSAP: this.$store.state.user.idClienteSAP,
            material: p.partnumber,
          };
          //console.log(param);

          this.price = 0;
          this.moneda = "";
          this.unidad = "";
          this.idProductoCliente = 0;

          if (!param.material && !param.clienteIdSAP) return;

          /*
          let request = await this.$http.put(
            route("Productos/getPrecioByMaterial"),
            param
          );
          */

          // console.log("response ProductoS" + JSON.stringify(request));

          //let producto = getResponse(request, null);

          // console.log("VAR Producto" + JSON.stringify(producto));

          //this.detalleProducto = producto;

          //console.log("VAR this.detalleProducto" + JSON.stringify(this.detalleProducto));
          ///console.log(this.detalleProducto);
          // console.log(p);

          validItems.push({
            cantidad: p.quantity,
          });

          /*
          if (this.detalleProducto.productos.length > 0) {
            if (
              p.quantity >= this.detalleProducto.productos[0].cantidadMinima ||
              this.detalleProducto.productos[0].cantidadMinima == 0
            ) {
              if (producto && producto.productos.length > 0) {
                let _producto = producto.productos[0];
                this.price = _producto.precioUnitario;
                this.moneda = _producto.moneda;
                this.unidad = _producto.unidadMedida;
                this.idProductoCliente = _producto.idProductoCliente;
                this.cantidadMinima = _producto.cantidadMinima;
                validItems.push({
                  price: _producto.precioUnitario,
                  moneda: _producto.moneda,
                  unidad: _producto.unidadMedida,
                  idProductCliente: _producto.idProductoCliente,
                  cantidad: p.quantity,
                  cantidadMinima: _producto.cantidadMinima,
                });
              } else {
                errors.push(p);
              }
            } else {
              this.notifyMessage(
                "danger",
                this.$t("app.modules.product_family_detail.errors.no_min_qty") +
                  ": " +
                  this.detalleProducto.productos[0].cantidadMinima +
                  " for the product " +
                  p.partnumber
              );
            }
          } else {
            if (!param.material) {
              this.notifyMessage(
                "danger",
                this.$t("app.cart.promps.noMaterial")
              );
            } else {
              this.notifyMessage(
                "danger",
                this.$t("app.cart.promps.noPriceForProduct") +
                  ": " +
                  p.partnumber
              );
            }
          }*/
        }

        if (errors.length > 0) {
          let partsNumbers = errors.map((item) => item.partnumber);

          this.notifyMessage(
            "danger",
            `
                ${this.$t("app.modules.add_by_part_number.product_not_cte")}
                :
                ${partsNumbers.join(", ")}
              `
          );
        }
      } else {
        this.notifyMessage(
          "danger",
          this.$t("app.modules.product_family_detail.errors.no_material") +
          ": " +
          p.partnumber
        );
      }

      return validItems;
    },

    async crearCotizacion() {
      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html: '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false,
      });

      try {
        let param = {
          cliente_idCliente: this.$store.state.user.idCliente,
          producto_idProducto: this.getProducto(),
          direccionEntrega_idDireccionEntrega: this.direccionId,
          usuarios_idSolicitante: this.$store.state.user.idUsuario,
          usuarios_idUsuario: this.$store.state.user.idUsuario,
        };

        if (!param.direccionEntrega_idDireccionEntrega)
          throw new Error(
            this.$t("app.modules.product_family_detail.errors.no_direction")
          );
        if (!param.producto_idProducto)
          throw new Error(
            this.$t("app.modules.product_family_detail.errors.no_product")
          );
        if (!param.cliente_idCliente)
          throw new Error(
            this.$t("app.modules.product_family_detail.errors.no_client")
          );

        let payload = {
          claveIdioma: this.$store.state.lang,
          cotizacion: param,
        };

        let request = await this.$http.post(
          route("Cotizacion/addCotizacion"),
          payload
        );
        let response = getResponse(request, null);

        if (response != null) {
          this.$swal.fire({
            text: this.$t(
              "app.modules.product_family_detail.messages.quote_success"
            ),
            showConfirmButton: true,
          });

          this.notifyMessage("success", this.$t("app.promps.save_success"));
        } else {
          this.notifyMessage("danger", this.$t("app.promps.error"));
          this.$swal.close();
        }
      } catch (e) {
        this.notifyMessage("danger", e.message);
        this.$swal.close();
      }
    },
    getProducto() {
      let ids = [];
      let countVals = 0;
      this.filters.forEach((filter, index) => {
        if (!!filter.value) {
          countVals++;
          if (ids.length === 0) {
            this.tableData[index].forEach((sub, subindex) => {
              if (sub !== undefined && sub.name === filter.value)
                ids.push(subindex);
            });
          } else if (ids.length > 1) {
            let temIds = [];
            ids.forEach((val) => {
              if (
                this.tableData[index][val] !== undefined &&
                filter.value === this.tableData[index][val].name
              )
                temIds.push(val);
            });
            ids = temIds;
          }
        }
      });

      return ids.length < 1 || countVals !== this.filters.length
        ? null
        : this.tableData[0][ids[0]].idProducto;
    },
    async loadPrecio() {
      let param = {
        direccionId: this.direccionId,
        productoId: this.getProducto(),
        clienteIdSAP: this.$store.state.user.idClienteSAP,
      };
      //console.log(param);
      this.price = 0;
      this.moneda = "";
      this.unidad = "";
      this.idProductoCliente = 0;

      if (!param.direccionId || !param.productoId || !param.clienteIdSAP)
        return;

      let request = await this.$http.put(
        route("Productos/getPrecioByProducto"),
        param
      );
      let response = getResponse(request, null);

      if (response && response.productos.length > 0) {
        let producto = response.productos[0];
        this.price = producto.precioUnitario;
        this.moneda = producto.moneda;
        this.unidad = producto.unidadMedida;
        this.idProductoCliente = producto.idProductoCliente;
      }
    },
    async addProducto() {
      //console.log("addProducto");

      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html: '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false,
      });

      var fechatest = new Date();
      fechatest.setDate(fechatest.getDate() + 30);

      let itemsToCart = [];

      if (this.productsList.length > 0) {
        //console.log("this.productsList.length: " + this.productsList.length);
        //console.log(
        //  "Datos de productsList " + JSON.stringify(this.productsList)
        //);

        for (let p of this.productsList) {

          console.log(
            "Datos de productsList " + JSON.stringify(this.productsList)
          );

          console.log(
            "Datos de p en productList " + JSON.stringify(p)
          );

          if (p.partnumber != null && p.quantity != null) {
            console.log(
              "Datos de p es null"
            );


            try {
              let payload = {
                idProductoCliente: p.idProductCliente,
                cantidad: parseInt(p.quantity),
                fechaEntrega: fechatest,
                material: p.partnumber.toString(),
              };

              if (payload.material && !payload.cantidad)
                throw new Error(
                  this.$t("app.modules.product_family_detail.errors.no_quantity")
                );

              if (!payload.material && payload.cantidad)
                throw new Error(
                  this.$t("app.modules.product_family_detail.errors.no_material")
                );

              if (!payload.material && !payload.cantidad) {
                //itemsToCart.push(payload);
                throw new Error(
                  this.$t("app.modules.product_family_detail.errors.no_info")
                );

              }

              itemsToCart.push(payload);
            } catch (e) {
              console.log(e);
              this.notifyMessage("danger", e.message);
            } finally {
              this.$swal.close();
            }




            //console.log("Antes de itemsToCart");

            /*
            if (itemsToCart.length > 0) {
              //console.log("itemsToCart mayor a 0");
              for (let item of itemsToCart) {
                EventBus.$emit("add-to-cart", item);
              }
    
              //poner aqui limpieza de carrito
              this.init();
              
            } else {
              this.$swal.close();
            }*/


          } else {

            this.notifyMessage("danger", this.$t("app.modules.product_family_detail.errors.no_info"));
            this.$swal.close();

          }


        }

        if (itemsToCart.length > 0) {

          EventBus.$emit("add-to-cart-list", itemsToCart);
          this.init();

        }



      } else {
        this.$swal.close();
      }
    },
    openFile(file) {
      window.open(file, "_blank");
    },
    changeOption(filterIndex) {
      //console.log("Entra aqui-filtro");
      for (let i = filterIndex; i < this.filters.length - 1; i++) {
        this.filters[i + 1].value = "";
      }
      this.loadPrecio();
    },
    eliminarRepetidos(result) {
      let response = [];
      result.forEach((data) => {
        let nData = [];
        data.forEach((sub) => {
          if (sub !== undefined) {
            let ind = nData.findIndex((i) => i.name === sub.name);
            if (ind === -1) nData.push(sub);
          }
        });
        response.push(nData);
      });
      return response;
    },
    getIds(data, value) {
      let ids = [];
      data.forEach((filter, index) => {
        if (filter.name === value) ids.push(index);
      });
      return ids;
    },
    async increaseViews(id) {
      let request = await this.$http.put(
        route("FamiliasProducto/increaseViews"),
        { id: id }
      );
      let response = getResponse(request);
    },
    reset() {
      //console.log("entro a reset");
      this.idFamilia = 0;
      this.product_family = new FamiliaProducto();
      this.curTrad = null;
      this.icon = "";
      this.groups = [];
      this.features = [];
      this.products = [];
      this.filters = [];
      this.tableData = [];
      this.addresses = [];
      this.quantity = 0;
      this.delivery_date = "";
      this.direccionId = "";
      this.price = 0;
      this.moneda = "";
      this.unidad = "";
      this.idProductoCliente = 0;
      this.productsList = [
        {
          direccionId: null,
          partnumber: null,
          quantity: null,
        },
      ];
    },
    async getProductDetail(id) {
      let item = false;

      const params = {
        idProducto: id,
      };
      //console.log(params);
      try {
        //console.log(params);
        let productoRequest = await this.$http.post(
          route("Productos/getInformacionProductoID"),
          params
        );

        let producto = getResponse(
          productoRequest,
          null,
          (body) => body.producto
        );

        //console.log("producto --> + " + producto);
        producto = producto || null;

        this.detallesProducto = producto;
        item = producto;
        // this.handleProduct(this.producto);
      } catch (e) {
        console.error(e);
      }

      return item;
    },
    openGroupAdd() {
      EventBus.$emit("grupoPropiedadFamiliaProductoAdd");
    },
    async getProductDetailVal(partNumber) {
      let param = {
        direccionId: this.idDireccion,
        clienteIdSAP: this.$store.state.user.idClienteSAP,
        material: partNumber,
      };

      if (!param.direccionId || !param.material || !param.clienteIdSAP) return;

      let request = await this.$http.put(
        route("Productos/getPrecioByMaterial"),
        param
      );

      let producto = getResponse(request, null);

      if (producto.productos.length > 0) {
        this.unidad = producto.productos[0].unidadMedida;
      }
    },
  },
  watch: {
    /*
    $route(to, from) {
      this.init();
    },*/
  },
};
</script>

<style></style>
<style scoped>
.icon-image {
  width: 100%;
  border-radius: 10px;
}

.button_download {
  color: #2c2c2c !important;
  font-size: 13px !important;
  padding-left: 0;
  margin: 0;
}

.button_download>i {
  font-size: 30px !important;
  padding-right: 20px !important;
  color: #e83734;
}
</style>
